import {useState} from "react";
import {gql, useMutation, useSubscription} from "@apollo/client";
import {Button, Descriptions, Form, Input, Radio, Select, DatePicker, Typography} from "antd";
import {授权日期} from "./config";
import {chatAI} from "./chatAI";
import {UploadOutlined} from '@ant-design/icons';
import {SelectUpload} from "./component/SelectUpload";
import {Attachments} from "./component/Attachments";
const {Title, Paragraph, Text, Link} = Typography;
const {TextArea} = Input;
const dayjs = require('dayjs')
export default function Zccqhz() {
    const [value, setValue] = useState(window.location.hash.split("?")[1] || '');

    const handleChange = (newValue) => {
        setValue(newValue);
        window.location.hash = (window.location.hash.split("?")[0] || window.location.hash) + '?' + newValue
    };
    const [form] = Form.useForm();
    const {data: theRDData, loading: theMndsbDataLoading} = useSubscription(
        gql`subscription MySubscription($id: uuid = "") {
            zccqhz_by_pk(id: $id) {
                created_at
                id
                mndsb
                propertyAccredit
                propertyCategory
                propertyName
                propertyNo
                propertyWay
                txtDate
                updated_at
                mndsbObj {
                    _glykj
                    _jscxgl
                    _kjcgzh
                    _zscqjz
                    basics_cost
                    china_cost
                    company
                    created_at
                    ent_hr_abroed
                    ent_hr_age1
                    ent_hr_age2
                    ent_hr_age3
                    ent_hr_age4
                    ent_hr_bachelor
                    ent_hr_doctor
                    ent_hr_ext
                    ent_hr_forg
                    ent_hr_junior
                    ent_hr_master
                    ent_hr_mechanic
                    ent_hr_middle
                    ent_hr_on_job
                    ent_hr_part
                    ent_hr_primary
                    ent_hr_senior
                    ent_hr_total
                    ent_hr_tsdplan
                    enterprise_income
                    id
                    net_asset1
                    net_asset2
                    net_asset3
                    sales_revenue1
                    sales_revenue2
                    sales_revenue3
                    sat_hr_abroed
                    sat_hr_ext
                    sat_hr_forg
                    sat_hr_on_job
                    sat_hr_part
                    sat_hr_total
                    year
                    updated_at
                    total_profit3
                    total_profit2
                    total_profit1
                    sat_hr_tsdplan
                    zccqhzs {
                        created_at
                        id
                        mndsb
                        propertyAccredit
                        propertyCategory
                        propertyName
                        propertyNo
                        propertyWay
                        txtDate
                        updated_at
                    }
                    gxjscps {
                        PGjjszb
                        PJzys
                        PZscqqk
                        Psfzycpstatus
                        cod
                        created_at
                        id
                        mndsb
                        productName
                        shr
                        technologyS
                        updated_at
                    }
                    companyObj {
                        updated_at
                        tyshxydm
                        qymc
                        id
                        created_at
                        clsj
                    }
                }
                 attachments {
                    updated_at
                    text
                    path
                    name
                    item
                    id
                    description
                    created_at
                }
            }
        }

        `, {
            variables: {id: value},
            shouldResubscribe: true
        },
    )
    const zccqhzInitialValues = {...(theRDData || {}).zccqhz_by_pk};
    if ((theRDData || {}).zccqhz_by_pk) {
        for (let k of 授权日期) {
            if ((theRDData || {}).zccqhz_by_pk[k]) {
                zccqhzInitialValues[k] = dayjs((theRDData || {}).zccqhz_by_pk[k])
            }
        }
    }
    const [update_zccqhz_by_pk, {error}] = useMutation(gql`mutation MyMutation($id: uuid = "", $zccqhz: zccqhz_set_input = {}) {
        update_zccqhz_by_pk(pk_columns: {id: $id}, _set: $zccqhz) {
            id
        }
    }
    `);
    return (
        <>
            {(theRDData || {}).zccqhz_by_pk && <>
                <Descriptions title=" " bordered>
                    <Descriptions.Item label="企业名称"
                                       span={2}>{theRDData.zccqhz_by_pk.mndsbObj.companyObj.qymc}
                    </Descriptions.Item>
                    <Descriptions.Item label="申报年度"
                                       span={2}>{theRDData.zccqhz_by_pk.mndsbObj.year}</Descriptions.Item>
                    <Descriptions.Item label="统一社会信用代码"
                                       span={2}>{theRDData.zccqhz_by_pk.mndsbObj.companyObj.tyshxydm}</Descriptions.Item>
                    <Descriptions.Item
                        label="成立时间"
                        span={2}>{new Date(theRDData.zccqhz_by_pk.mndsbObj.companyObj.clsj).toLocaleDateString()}</Descriptions.Item>
                    <Descriptions.Item label="知识产权编号：IP"
                                       span={2}>{theRDData.zccqhz_by_pk.propertyNo}</Descriptions.Item>
                    <Descriptions.Item label="知识产权名称"
                                       span={2}>{theRDData.zccqhz_by_pk.propertyName}</Descriptions.Item>
                </Descriptions>
                <div style={{padding: '10px'}}></div>
                <Form
                    name="basic"
                    labelCol={{
                        span: 32,
                    }}
                    wrapperCol={{
                        span: 32,
                    }}
                    style={{
                        maxWidth: 800,
                    }}
                    initialValues={zccqhzInitialValues}
                    onFinish={(values) => {
                        console.log(values)
                        // for (let k of 上年度销售收入字段) {
                        //     if (values[k]) {
                        //         values[k] = string10000ToMoney(values[k])
                        //     }
                        // }


                        update_zccqhz_by_pk({
                            variables: {
                                id: value,
                                zccqhz: values
                            }
                        }).fankui().then(value1 => window.history.back())
                        // insert_mndsb({variables: {year: e.year.$y, company: theCompanyData.company[0].id}})
                    }}
                    onFinishFailed={(e) => {
                        console.error(e)
                    }}
                    autoComplete="off"
                    form={form}
                >
                    <Form.Item
                        label="知识产权编号：IP "
                        name="propertyNo"
                        rules={[{required: true, message: '请输入内容'}]}
                        style={{display: 'inline-flex', width: '50%'}}

                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="类别"
                        name="propertyCategory"
                        rules={[{required: true, message: '请选择'}]}
                        style={{display: 'inline-flex', width: '50%'}}

                    >
                        <Select
                            style={{ width: 200 }}>
                            <Select.Option defaultvalue="0">请选择</Select.Option>
                            <Select.Option value="1">实用新型专利</Select.Option>
                            <Select.Option value="2">外观设计专利</Select.Option>
                            <Select.Option value="3">软件著作权</Select.Option>
                            <Select.Option value="4">发明专利（非国防专利）</Select.Option>
                            <Select.Option value="5">发明专利（国防专利）</Select.Option>
                            <Select.Option value="6">植物新品种</Select.Option>
                            <Select.Option value="7">国家级农作物品种</Select.Option>
                            <Select.Option value="8">国家新药</Select.Option>
                            <Select.Option value="9">国家一级中药保护品种</Select.Option>
                            <Select.Option value="10">集成电路布图设计专有权</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="专利号"
                        name="propertyAccredit"
                        rules={[{required: true, message: '请输入内容'}]}
                        style={{display: 'inline-flex', width: '50%'}}

                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="知识产权名称"
                        name="propertyName"
                        rules={[{required: true, message: '请输入内容'}]}
                        style={{display: 'inline-flex', width: '50%'}}

                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="获得方式"
                        name="propertyWay"
                        rules={[{required: true, message: '请选择'}]}
                        style={{display: 'inline-flex', width: '50%'}}

                    >
                        <Select
                            style={{ width: 200 }}
                        >
                            <Select.Option defaultvalue="0">请选择</Select.Option>
                            <Select.Option value="1">其他</Select.Option>
                            <Select.Option value="2">自主研发</Select.Option>
                            <Select.Option value="3">受让</Select.Option>
                            <Select.Option value="4">受赠</Select.Option>
                            <Select.Option value="5">并购</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="授权日期"
                        name="txtDate"
                        rules={[{required: true, message: '请输入日期'}]}
                        style={{display: 'inline-flex', width: '50%'}}

                    >
                        <DatePicker/>
                    </Form.Item>
                    <h3>附件 <UploadOutlined/></h3>
                    <SelectUpload
                        item={value}
                        nameList={["知识产权证书", "最新缴费发票凭证", "技术水平证明", "其他证明材料"]}/>
                    <Attachments attachments={theRDData.zccqhz_by_pk.attachments}/>
                    <Paragraph>
                        请上传知识产权相关材料（知识产权证书及反映技术水平的证明材料等）。
                        <br/>
                        <b>注:转让获得的专利还需上传登记合同</b>
                        <h5>认定机构具体要求如下：</h5>
                        1. 企业获得的授权知识产权证书及最近一次缴费证明复印件，授权通知书及缴费收据复印件；<br/>
                        2. 通过受让、受赠、并购取得的知识产权需要提供相关主管部门出具的变更证明、协议和备案证明等；<br/>
                        3.知识产权有多个权属人时，需提供其他权属人同意该企业使用知识产权申报高新技术企业的声明，所有权属人需加盖公章；<br/>
                        4.反映技术水平的证明材料（如专利说明书等）。<br/>
                        顺序为：专利证书————专利缴费证明————技术水平证明————其他证明材料
                        <h5>附件格式要求：</h5>

                        1、证明材料扫描上传。<br/>

                        2、只支持非加密PDF格式的文件上传。<br/>

                        3、单个文件大小不要超过2M。
                    </Paragraph>
                    <Form.Item wrapperCol={{offset: 8, span: 8}}>
                        <Button type="primary" htmlType="submit">
                            确定
                        </Button>
                    </Form.Item>
                </Form>


            </>}
        </>
    )
}
